import { PostOfficeContextProvider as PostOfficeBaseProvider } from '@atlassian/post-office-frontend';
import React, { useMemo } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

interface PostOfficeContextProviderProps {
  children: React.ReactNode;
}

/*
 * This component is used to provide the PostOfficeContext to the application. It provides the product, subproduct and locale at the application level.
 */
const PostOfficeContextProviderImpl = ({ intl, children }: InjectedIntlProps & PostOfficeContextProviderProps) => {
  const providerValue = useMemo(
    () => ({
      product: 'uchi',
      subproduct: 'web',
      locale: intl.locale,
    }),
    [intl.locale],
  );

  return <PostOfficeBaseProvider value={providerValue}>{children}</PostOfficeBaseProvider>;
};

export const PostOfficeContextProvider = injectIntl(PostOfficeContextProviderImpl);
